module.exports = __webpack_public_path__ + "img/wechat.1885135f.png";